import React from 'react'
import { StyledCheckIcon, StyledMinusIcon, StyledPlusIcon, StyledUpArrowIcon, StyledDownArrowIcon } from './StyledIcons'

export function getBoxIcon(idx: number, isActive: boolean): React.ReactNode {
  switch (idx) {
    case 0:
      return <StyledDownArrowIcon isActive={isActive} />
    case 1:
      return <StyledMinusIcon isActive={isActive} />
    case 2:
      return <StyledCheckIcon isActive={isActive} />
    case 3:
      return <StyledPlusIcon isActive={isActive} />
    case 4:
      return <StyledUpArrowIcon isActive={isActive} />
    default:
      return null
  }
}
